/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carousel_PrevInputs */

const en_carousel_prev = /** @type {(inputs: Carousel_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous slide`)
};

const ar_carousel_prev = /** @type {(inputs: Carousel_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الشريحة السابقة`)
};

const bn_carousel_prev = /** @type {(inputs: Carousel_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আগের স্লাইড`)
};

const de_carousel_prev = /** @type {(inputs: Carousel_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorherige Folie`)
};

const es_carousel_prev = /** @type {(inputs: Carousel_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diapositiva anterior`)
};

const fr_carousel_prev = /** @type {(inputs: Carousel_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diapositive précédente`)
};

const pt_carousel_prev = /** @type {(inputs: Carousel_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slide anterior`)
};

const zh_carousel_prev = /** @type {(inputs: Carousel_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上一张幻灯片`)
};

const tr_carousel_prev = /** @type {(inputs: Carousel_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önceki slayt`)
};

const ru_carousel_prev = /** @type {(inputs: Carousel_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предыдущий слайд`)
};

const pl_carousel_prev = /** @type {(inputs: Carousel_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poprzedni slajd`)
};

/**
* | output |
* | --- |
* | "Previous slide" |
*
* @param {Carousel_PrevInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const carousel_prev = /** @type {((inputs?: Carousel_PrevInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carousel_PrevInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_carousel_prev(inputs)
	if (locale === "bn") return bn_carousel_prev(inputs)
	if (locale === "de") return de_carousel_prev(inputs)
	if (locale === "es") return es_carousel_prev(inputs)
	if (locale === "fr") return fr_carousel_prev(inputs)
	if (locale === "pt") return pt_carousel_prev(inputs)
	if (locale === "zh") return zh_carousel_prev(inputs)
	if (locale === "tr") return tr_carousel_prev(inputs)
	if (locale === "ru") return ru_carousel_prev(inputs)
	if (locale === "pl") return pl_carousel_prev(inputs)
	return en_carousel_prev(inputs)
});